export const Labels = {
  standard: {
    addressLine1: 'Address Line 1:',
    addressLine2: 'Address Line 2:',
    city: 'City:',
    state: 'State:',
    zipCode: 'ZIP Code:',
  },
  simple: {
    addressLine1: 'Address',
    city: 'City',
    state: 'State',
    zipCode: 'ZIP Code',
  },
  homeowner: {
    addressLine1: 'Street address',
    city: 'City',
    state: 'State',
    zipCode: 'ZIP code',
  },
  billing: {
    addressLine1: 'Billing address',
    city: 'City:',
    state: 'State:',
    zipCode: 'ZIP Code:',
  },
};

export const Names = {
  standard: {
    addressLine1: 'addressLine1',
    addressLine2: 'addressLine2',
    city: 'city',
    state: 'state',
    zipCode: 'zipCode',
  },
  homeowner: {
    addressLine1: 'homeownerInfo.addressLine1',
    addressLine2: 'homeownerInfo.addressLine2',
    city: 'homeownerInfo.city',
    state: 'homeownerInfo.state',
    zipCode: 'homeownerInfo.zipCode',
  },
  company: {
    addressLine1: 'companyContact.companyAddressLine1',
    addressLine2: 'companyContact.companyAddressLine2',
    city: 'companyContact.companyCity',
    state: 'companyContact.companyState',
    zipCode: 'companyContact.companyZIPCode',
  },
  billing: {
    addressLine1: 'billingManagerContact.billingManagerAddress',
    city: 'billingManagerContact.billingManagerCity',
    state: 'billingManagerContact.billingManagerState',
    zipCode: 'billingManagerContact.billingManagerZIPCode',
  },
};
